<mono-common-back-to-navigation-bar data-test="lmw-base-contact-us-back-to-home-bar-top"
  [linkText]="mobileBackButtonText" linkTo="/" position="back-to-navigation__top"></mono-common-back-to-navigation-bar>
<main class="site-container" aria-describedby="ariaMainHeaderId">
  <div class="grid-container">
    <div class="grid-x grid-margin-x">
      <div class="cell">
        <h1 id="ariaMainHeaderId">
          {{ reportAnIssueCmsData?.data?.attributes?.title }}
        </h1>
        <ng-container *ngIf="!userSignedIn">
          <div [innerHTML]="
              reportAnIssueCmsData?.data?.attributes?.signedOutDescription | dontSanitizeHtml
            "></div>
        </ng-container>
        <ng-container *ngIf="userSignedIn">
          <div [innerHTML]="
            reportAnIssueCmsData?.data?.attributes?.signedInDescription | dontSanitizeHtml
          "></div>
        </ng-container>
        <form *ngIf="!enquirySent && !userSignedIn" class="form form--full-page" [formGroup]="enquiryForm"
          (ngSubmit)="sendEnquiry()" #form>
          <mono-common-help-popup [title]="
              reportAnIssueCmsData?.data?.attributes?.signedOutForm?.helpPopup?.title
            " [message]="
              reportAnIssueCmsData?.data?.attributes?.signedOutForm?.helpPopup?.description
            " [open]="helpPopupOpen" [shadow]="true" (removeHelpMessage)="onCloseHelpPopup($event)"
            helpPopupCalledFrom="local-support"></mono-common-help-popup>
          <div class="help-popup-button-strip flex-container align-right">
            <button #helpPopupRef data-test="lmw-base-contact-us-open-help-popup-button" class="button clear underline"
              type="button" (click)="onOpenHelpPopup()">
              {{
              reportAnIssueCmsData?.data?.attributes?.signedOutForm
              ?.helpPopupButtonText
              }}
              <svg class="icon icon--help-circle icon--secondary">
                <use xlink:href="#icon-help" href="#icon-help"></use>
              </svg>
            </button>
          </div>
          <fieldset [disabled]="showLoader" aria-required="true" class="flex-container flex-dir-column">
            <legend class="show-for-sr">Contact us form</legend>
            <div class="form-item">
              <label class="large-text-medium" for="fullName" id="fullNameAriaId">{{
                reportAnIssueCmsData?.data?.attributes?.signedOutForm
                ?.fullNameLabel
                }}</label>
              <input type="text" id="fullName" formControlName="fullName" autocomplete="off"
                aria-labelledby="fullNameAriaId" aria-required="true" />
            </div>
            <div class="form-item">
              <label class="large-text-medium" for="emailOrMobile" id="emailOrMobileAriaId">{{
                reportAnIssueCmsData?.data?.attributes?.signedOutForm
                ?.emailLabel
                }}</label>
              <input type="text" id="emailOrMobile" formControlName="emailOrMobile"
                aria-labelledby="emailOrMobileAriaId" aria-required="true" />
              <mono-common-callout data-test="lmw-base-contact-us-email-callout-info" animation="no-animation"
                base="info" type="info-text" [calloutText]="
                  reportAnIssueCmsData?.data?.attributes?.signedOutForm
                    ?.emailInputInformation.text
                "
                [ariaLabel]="reportAnIssueCmsData?.data?.attributes?.signedOutForm?.emailInputInformation.ariaLabel"></mono-common-callout>
            </div>

            <div class="form-item">
              <label class="large-text-medium" for="enquiry" id="enquiryAriaId">{{
                reportAnIssueCmsData?.data?.attributes?.signedOutForm
                ?.enquiryForm.label
                }}</label>
              <textarea formControlName="enquiry" name="enquiry" id="enquiry" rows="7"></textarea>
              <mono-common-callout data-test="lmw-base-contact-us-enquiry-callout-info" animation="no-animation"
                base="info" type="info-text" [calloutText]="
                  reportAnIssueCmsData?.data?.attributes?.signedOutForm
                    ?.enquiryForm?.informationText
                "
                [ariaLabel]="reportAnIssueCmsData?.data?.attributes?.signedOutForm?.enquiryForm?.informationAriaLabel"
                paddingOrMarginAlteration="margin-top-0"></mono-common-callout>
            </div>
            <div class="form-overlay" *ngIf="showLoader"></div>
            <button type="submit" class="button primary medium-down-expanded"
              data-test="lmw-base-contact-us-submit-button" [disabled]="!enquiryForm.valid || showLoader">
              <span *ngIf="!showLoader">{{
                reportAnIssueCmsData?.data?.attributes?.signedOutForm
                ?.sendEnquiryButton.text
                }}</span>
              <ng-container *ngIf="showLoader">
                <span>{{
                  reportAnIssueCmsData?.data?.attributes?.signedOutForm
                  ?.sendEnquiryButton?.loader
                  }}</span>
                <mono-common-loading-animation></mono-common-loading-animation>
              </ng-container>
            </button>
          </fieldset>
        </form>
        <form *ngIf="!enquirySent && userSignedIn" class="form form--full-page" [formGroup]="enquiryForm"
          (ngSubmit)="sendEnquiry()" #form>
          <fieldset [disabled]="showLoader" aria-required="true"
            class="flex-container flex-dir-column padding-top-0 margin-top-1-5">
            <legend class="show-for-sr">Contact us form</legend>
            <h2 class="margin-bottom-1-5">{{ reportAnIssueCmsData?.data?.attributes?.signedInForm?.title }}</h2>
            <div class="form-item margin-bottom-1-5">
              <label class="large-text-medium padding-left-0  margin-bottom-1" for="fullName" id="fullNameAriaId">{{
                reportAnIssueCmsData?.data?.attributes?.signedInForm?.fullNameLabel }}</label>
              <input type="text" id="fullName" formControlName="fullName" autocomplete="off"
                aria-labelledby="fullNameAriaId" aria-required="true"
                class="transparent-disabled padding-left-0 height-auto" />
            </div>
            <div class="form-item margin-bottom-1">
              <label class="large-text-medium padding-left-0 margin-bottom-1" for="emailOrMobile"
                id="emailOrMobileAriaId">
                <ng-container *ngIf="userUsesEmail">{{ reportAnIssueCmsData?.data?.attributes?.signedInForm?.emailLabel
                  }}</ng-container>
                <ng-container *ngIf="!userUsesEmail">{{
                  reportAnIssueCmsData?.data?.attributes?.signedInForm?.mobileLabel }}</ng-container>
              </label>
              <input type="text" id="emailOrMobile" formControlName="emailOrMobile"
                aria-labelledby="emailOrMobileAriaId" aria-required="true"
                class="transparent-disabled padding-left-0 height-auto margin-bottom-1" />
            </div>
            <p class="bold-text lead">{{ reportAnIssueCmsData?.data?.attributes?.signedInForm?.areDetailsCorrectTitle }}
              <span class="block smallest-text normal-text-weight">{{
                reportAnIssueCmsData?.data?.attributes?.signedInForm?.areDetailsCorrectInformation }}</span></p>
            <a class="button clear button--icon-on-left margin-bottom-2 justify-content-start"
              routerLink="/edit-my-details"><svg aria-hidden="true" viewBox="0 0 24 24" class="icon icon--edit">
                <use xlink:href="#icon-edit" href="#icon-edit"></use>
              </svg> {{ reportAnIssueCmsData?.data?.attributes?.signedInForm?.editDetailsLink }}</a>
            <hr class="section section--divider section--full-page-form margin-bottom-2" />
              <div class="form-item" *ngIf="
            this.userRole === 'supportLearnersAtCentre'">
                <label class="large-text-medium" for="organisationId" id="organisationIdAriaId">{{ reportAnIssueCmsData?.data?.attributes?.signedInForm?.centreNumberLabel }}</label>
                <input type="number" id="organisationId" formControlName="organisationId" aria-labelledby="organisationIdAriaId"
               class="centre-id" inputmode="numeric" />
                  <mono-common-callout data-test="lmw-base-contact-us-centre number-callout-info" animation="no-animation"
                base="info" type="info-text" [calloutText]="reportAnIssueCmsData?.data?.attributes?.signedInForm?.centreNumberInformation"
                ></mono-common-callout>
              </div>
            <div class="form-item">
              <label class="large-text-medium" for="enquiry" id="enquiryAriaId">{{
                reportAnIssueCmsData?.data?.attributes?.signedInForm
                ?.enquiryForm.label
                }}</label>
              <textarea formControlName="enquiry" name="enquiry" id="enquiry" rows="7"></textarea>
              <mono-common-callout data-test="lmw-base-contact-us-enquiry-callout-info" animation="no-animation"
                base="info" type="info-text" [calloutText]="
                reportAnIssueCmsData?.data?.attributes?.signedInForm
                  ?.enquiryForm?.informationText
                " [ariaLabel]="reportAnIssueCmsData?.data?.attributes?.signedInForm?.enquiryForm?.informationAriaLabel"
                paddingOrMarginAlteration="margin-top-0"></mono-common-callout>
            </div>
            <div class="form-overlay" *ngIf="showLoader"></div>
            <button type="submit" class="button primary medium-down-expanded"
              data-test="lmw-base-contact-us-submit-button" [disabled]="!enquiryForm.valid || showLoader">
              <span *ngIf="!showLoader">{{
                reportAnIssueCmsData?.data?.attributes?.signedInForm?.sendEnquiryButton?.text
                }}</span>
              <ng-container *ngIf="showLoader">
                <span>{{
                  reportAnIssueCmsData?.data?.attributes?.signedInForm?.sendEnquiryButton?.loader
                  }}</span>
                <mono-common-loading-animation></mono-common-loading-animation>
              </ng-container>
            </button>
          </fieldset>
        </form>
        <div #response id="submissionResponse" [ngClass]="enquirySent ? 'show' : 'hide'"
          class="form form--full-page hide" [ngStyle]="{ 'height.px': formHeight }">
          <div aria-hidden="true" class="form--full-page__help-button-wrapper"></div>
          <div *ngIf="successfulResponse" class="form--full-page__response">
            <h3>
              {{
              reportAnIssueCmsData?.data?.attributes?.enquiryFormResponse
              ?.successTitle
              }}
              <svg class="icon icon--checkmark icon--success" viewBox="0 0 48 48">
                <use xlink:href="#icon-checkmark" href="#icon-checkmark"></use>
              </svg>
            </h3>
            <p>
              {{
              reportAnIssueCmsData?.data?.attributes?.enquiryFormResponse
              ?.successDescription
              }}
            </p>
            <h4>
              {{
              reportAnIssueCmsData?.data?.attributes?.enquiryFormResponse
              ?.nextActionsTitle
              }}
            </h4>
            <div [innerHTML]="
                reportAnIssueCmsData?.data?.attributes?.enquiryFormResponse
                  ?.nextActionsDescription | dontSanitizeHtml
              "></div>
          </div>
          <div *ngIf="!successfulResponse" class="form--full-page__response">
            <div aria-hidden="true" class="form--full-page__help-button-wrapper"></div>
            <h3>
              {{
              reportAnIssueCmsData?.data?.attributes?.enquiryFormResponse
              ?.errorTitle
              }}
            </h3>
            <div [innerHTML]="
                reportAnIssueCmsData?.data?.attributes?.enquiryFormResponse
                  ?.errorDescription | dontSanitizeHtml
              "></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<mono-common-back-to-navigation-bar data-test="lmw-base-contact-us-back-to-home-bar-bottom"
  [linkText]="mobileBackButtonText" linkTo="/"
  position="back-to-navigation__bottom"></mono-common-back-to-navigation-bar>